import { SvgIcon, SvgIconProps } from '@mui/material';
import { memo } from 'react';
const SvgFlagDe = (props: SvgIconProps) => {
  const { sx, ...other } = props;
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      style={{
        shapeRendering: 'geometricPrecision',
        textRendering: 'geometricPrecision',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
      }}
      viewBox="0 0 290 174"
      sx={{
        ...sx,
      }}
      {...other}
    >
      <path
        d="M-.5-.5h290v58H-.5v-58Z"
        style={{
          opacity: 1,
        }}
      />
      <path
        fill="#d00"
        d="M-.5 57.5h290v58H-.5v-58Z"
        style={{
          opacity: 1,
        }}
      />
      <path
        fill="#ffce00"
        d="M-.5 115.5h290v58H-.5v-58Z"
        style={{
          opacity: 1,
        }}
      />
    </SvgIcon>
  );
};
const Memo = memo(SvgFlagDe);
export default Memo;
